const BERLIN_TIME_ZONE = 'Europe/Berlin';

const berlinDateFormatter = new Intl.DateTimeFormat('sv-SE', {
    timeZone: BERLIN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});

const berlinTimeFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: BERLIN_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
});

/** Calendar date in Europe/Berlin as YYYY-MM-DD (the single source of "today" for status rules). */
export function berlinDateString(date: Date | number = Date.now()): string {
    return berlinDateFormatter.format(typeof date === 'number' ? new Date(date) : date);
}

/** True when the value (YYYY-MM-DD string or Date) is today's Berlin date. */
export function isBerlinToday(value: Date | string | null | undefined, now: number = Date.now()): boolean {
    if (!value) return false;
    const dateStr = typeof value === 'string' ? value.slice(0, 10) : berlinDateString(value);
    return dateStr === berlinDateString(now);
}

/** Epoch ms of the most recent midnight in Europe/Berlin (DST-aware). */
export function berlinMidnightTimestamp(now: number = Date.now()): number {
    // On DST-change days a call after the 02:00/03:00 switch is off by 1h; acceptable, detection normally runs within seconds of midnight.
    const parts = berlinTimeFormatter.formatToParts(new Date(now));
    const read = (type: string) => parseInt(parts.find((p) => p.type === type)?.value ?? '0', 10);
    const hours = read('hour') % 24; // some engines print "24" at midnight
    const msElapsed = (hours * 3600 + read('minute') * 60 + read('second')) * 1000 + new Date(now).getUTCMilliseconds();
    return now - msElapsed;
}
